<div class="header">
  <div class="title">
    Upcoming events
    <mat-spinner *ngIf="loadingEvents" [diameter]="18"></mat-spinner>
  </div>
  <a
    class="calendar-icon"
    [routerLink]="['/calendar']"
    aria-label="Open calendar"
  >
    <mat-icon aria-hidden="true">calendar_month</mat-icon>
  </a>
</div>
<div *ngIf="hasEverScheduled === false" class="empty-state-text">
  <p class="empty-state-description">
    Add events to your Presence calendar to populate this space automatically.
  </p>
  <p class="empty-state-pro-tip">
    <strong>Pro tip:</strong> You can sync your Presence events to your existing
    Google, Apple, or Outlook calendar too!
  </p>
</div>
<div
  class="schedule-card"
  [class.demo-mode]="hasEverScheduled === false"
  #scheduleCard
>
  <div *ngIf="hasEverScheduled === false" class="frosted-overlay"></div>
  <div class="scroll-container" #scrollContainer>
    <div class="hours-column">
      <div
        *ngFor="let hour of hours"
        class="hour-label"
        [style.top.px]="hour.position"
      >
        {{ hour.label }}
      </div>
      <div
        *ngFor="let tick of majorTicks"
        class="tick-line major"
        [style.top.px]="tick"
      ></div>
      <div
        *ngFor="let tick of minorTicks"
        class="tick-line"
        [style.top.px]="tick"
      ></div>
    </div>
    <div class="events-column">
      <a
        *ngFor="let event of events"
        class="event-block"
        [class.translucent]="isHovering"
        [style.top.px]="event.top"
        [style.height.px]="event.height"
        [style.marginLeft.px]="event.marginLeft"
        [style.width.px]="totalWidth - event.marginLeft"
        [style.zIndex]="event.zIndex"
        [routerLink]="['/calendar']"
        (mouseenter)="isHovering = true"
        (mouseleave)="isHovering = false"
      >
        <ng-container *ngIf="getEventDuration(event) > 15; else shortEvent">
          <div class="event-title">{{ event.title }}</div>
          <div class="event-time">{{ event.duration }}</div>
        </ng-container>
        <ng-template #shortEvent>
          <div class="event-title">{{ event.title }}</div>
        </ng-template>
      </a>
      <div *ngIf="!loadingEvents && events.length === 0" class="no-events">
        No events today
      </div>
    </div>
  </div>
</div>
<div *ngIf="hasEverScheduled === false" class="empty-state-action">
  <a class="empty-state-button" mat-raised-button [routerLink]="['/calendar']">
    Add events
  </a>
</div>
